import {PropertyCardBalloon} from '../../classes/PropertyCard/PropertyCardBalloon';
import {
    PROPERTY_LISTING_CARD_MOUSE_ENTER,
    PROPERTY_LISTING_CARD_MOUSE_LEAVE
} from "../../components/PropertyListingCard/PropertyListingCard";
import {
    PROPERTY_SEARCH_DISABLED_OPTION
} from "../../mixins/PropertySearchMixin";
import {
    PROPERTY_MAP_CARD_FAVORITE_BUTTON_FAVORITE_ACTION,
    FAV_CLICK_LOADING
} from "../../mixins/FavoriteButtonMixin";
import {PROPERTY_SEARCH_ACTIONS, SEARCH_TABS} from "../../../helpers/variables";
import set from 'lodash/set';
import {VIEW_BREAKPOINTS} from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";

/**
 * @param google
 * @param map
 * @param marker
 * @param hasMarkerClusterer
 * @param router
 * @param bus
 * @param favoriteOptionEnabled
 * @param isVisible
 * @returns {CustomOverlayView}
 */
export function createCustomMarker(
    google,
    map,
    marker,
    hasMarkerClusterer = false,
    router,
    bus,
    favoriteOptionEnabled = true,
    propertyDetailsRoute = 'property.details.view',
    isVisible = true
) {
    const OverlayView = google.maps.OverlayView;
    const LatLng = google.maps.LatLng;

    class CustomOverlayView extends OverlayView {
        constructor() {
            super();
            this.map = map;
            this.divWrapper = null;
            this.activeWindows = [];
            this.latLng = new LatLng(marker.latLng.lat, marker.latLng.lng);
            this.favoriteOptionEnabled = favoriteOptionEnabled;
            this.favoriteBtnDisabled = false;
            this.isVisible = isVisible;
            if (!hasMarkerClusterer) {
                this.setMap(map);
            }
            this.propertyImage = {
                loaded: false,
                url: null
            };

            this.propertyCardBalloon = new PropertyCardBalloon(bus);
        }

        /**
         * set isVisible=false if you want not to include the marker into a cluster
         * @returns {boolean}
         */
        getVisible() {
            return this.isVisible;
        }

        /**
         * onAdd is called when the map's panes are ready and the overlay has been added to the map.
         */
        onAdd() {
            this.bindTemplateToWrapper();
            this.bindWrapperToOverlay();
            this.bindEventsToWrapper();
        }

        /**
         * onRemove is called when setMap(null) has been called on the overlay.
         */
        onRemove() {
            this.divWrapper.parentNode.removeChild(this.divWrapper);
            this.divWrapper = null;
        }

        bindTemplateToWrapper() {
            let divWrapper = document.createElement('div');
            divWrapper.style.position = 'absolute';

            divWrapper.innerHTML = marker.templateIcon();
            this.divWrapper = divWrapper;
        }

        bindWrapperToOverlay() {
            this.getPanes().overlayMouseTarget.appendChild(this.divWrapper);
        }

        onPropertyDetailsPage() {
            let routePath = router.currentRoute.path || '',
                routeName = router.currentRoute.name || '';

            if (routeName || routePath) {
                let against = {
                        ...(
                            typeof propertyDetailsRoutee == 'string'
                                ? {name: propertyDetailsRoute}
                                : propertyDetailsRoute
                        ),
                        ...{name: 'property.details.view', path: '/property-details/:id'}
                    },
                    againstPath = against.path.split('/')
                        .filter(v => Boolean(v) && (v.indexOf('detail') || v.indexOf('property')))[0],
                    againstName = against.name;

                return routePath && againstPath && routePath.indexOf(`/${againstPath}`) > -1 ||
                    routeName && againstName && routeName.indexOf(againstName) > -1;
            }

            return false;
        }

        goToDetailsPage(propertyUuid) {
            let detailsRoute = typeof propertyDetailsRoute === 'string'
                ? {name: propertyDetailsRoute}
                : propertyDetailsRoute;

            if (!detailsRoute.params) {
                detailsRoute.params = {};
            }
            detailsRoute.params.id = propertyUuid;

            if (window.innerWidth <= VIEW_BREAKPOINTS.MOBILE) {
                set(detailsRoute, 'query.searchTab', SEARCH_TABS.MAP);
            }

            router.push(detailsRoute);
        }

        bindEventsToWrapperChild(elem) {
            const self = this;

            elem.addEventListener('mouseover', event => {
                self.showInfoWindow();
            });

            elem.addEventListener('click', event => {
                if (self.onPropertyDetailsPage()) {
                    return;
                }
                if (window.innerWidth < 768) {
                    return self.showInfoWindow();
                }
                self.goToDetailsPage(marker.attributes._uuid);
            });
        }

        bindEventsToWrapper() {
            if (this.divWrapper.children.length === 0) {
                return;
            }

            marker.htmlElem = this.propertyCardBalloon.retrieveHtml(marker.attributes, this.isVisible);

            this.bindEventsToWrapperChild(this.divWrapper.children[0]);

            if (this.divWrapper.children.length >= 2) {
                this.bindEventsToWrapperChild(this.divWrapper.children[1]);
            }

            bus.$on(PROPERTY_LISTING_CARD_MOUSE_ENTER, (uuid) => {
                let propertyUuid = marker.attributes._uuid;
                if (marker.attributes._uuid == uuid && Boolean(marker.templateCard())) {
                    if (this.divWrapper != null) {
                        google.maps.event.trigger(this.divWrapper.children[0], 'mouseover', {});
                        this.divWrapper.children[1].classList.add("dot-hovered");
                        this.activeWindows = [];
                        this.activeWindows.push(this.map.infoWindow);
                    }
                }
            });

            bus.$on(PROPERTY_LISTING_CARD_MOUSE_LEAVE, (uuid) => {
                let propertyUuid = marker.attributes._uuid;
                if (marker.attributes._uuid == uuid) {
                    if (this.divWrapper != null) {
                        const secondChild = this.divWrapper.children[1];
                        if (secondChild) {
                            secondChild.classList.remove("dot-hovered");
                        }
                        setTimeout(() => {
                            this.closeActiveInfoWindow(this.activeWindows.shift());
                        }, 2000);
                    }
                }
            });

            bus.$on(FAV_CLICK_LOADING, (value, uuid) => {
                this.favoriteBtnDisabled = value;
            });
            bus.$on(PROPERTY_MAP_CARD_FAVORITE_BUTTON_FAVORITE_ACTION, (value, uuid) => {
                if (!this.favoriteOptionEnabled) {
                    bus.$emit(PROPERTY_SEARCH_DISABLED_OPTION, PROPERTY_SEARCH_ACTIONS.FAVORITE, {propertyUuid: uuid});
                } else {
                    if (this.map && this.map.infoWindow && marker.attributes._uuid == uuid) {
                        let infoWindowContent = this.map.infoWindow.content;
                        let favButton = infoWindowContent.querySelector('.property-listing-card-favorite-button')
                            .querySelector('.fav-btn');

                        marker.attributes.isFavorite = !!value;
                        this.toggleFavoritePropertyClassList(favButton, !!value);

                        this.map.infoWindow.setContent(infoWindowContent);
                    }
                }
            });
        }

        /**
         * method invoked when overlay is clicked
         */
        showInfoWindow() {
            if (this.map.infoWindow) {
                this.closeActiveInfoWindow();
            }
            this.setActiveInfoWindow();
            this.bindEventsToMap();

            if (this.map.infoWindow) {
                this.map.infoWindow.open({map, shouldFocus: false});
                this.setImage();
            }

        }

        setActiveInfoWindow() {
            this.map.infoWindow = null;
            this.map.activeMarker = this.divWrapper;

            var layer = document.createElement("div");
            if (!Boolean(marker.templateCard())) {
                return;
            }
            layer.innerHTML = marker.templateCard();

            let favButton = layer.querySelector('.property-listing-card-favorite-button');

            if (favButton) {
                const favBtnIcon = favButton.querySelector('.fav-btn');
                this.toggleFavoritePropertyClassList(favBtnIcon, marker.attributes.isFavorite);
                if (this.favoriteOptionEnabled) {
                    let self = this;
                    favButton.onclick = function () {
                        let property = marker.attributes || {};
                        if (self.favoriteBtnDisabled) {
                            return;
                        }
                        bus.$emit(
                            PROPERTY_MAP_CARD_FAVORITE_BUTTON_FAVORITE_ACTION,
                            !property.isFavorite,
                            property._uuid,
                            property
                        );
                    };
                }
            }

            const card = layer.querySelector('.card.property-card');
            if (card) {
                let self = this;
                card.onclick = function (event) {
                    if (event.srcElement.tagName === 'I' && event.srcElement.classList.contains('fa-heart')) {
                        return;
                    }
                    if (self.onPropertyDetailsPage()) {
                        return;
                    }
                    self.goToDetailsPage(marker.attributes._uuid);
                };
            }

            this.map.infoWindow = new google.maps.InfoWindow({
                content: layer,
                position: marker.latLng,
                pixelOffset: this.getInfoWindowOffsetRelativeToMarker(marker),
                disableAutoPan: true,
                maxWidth: 256,
            });


            this.addActiveMarkerClassList();
        }

        setImage() {
            let infoWindowContent = this.map.infoWindow.getContent();
            let imgLoader = infoWindowContent.querySelector('.property-card-balloon-image-loader');

            if (!imgLoader) {
                return;
            }

            let replaceImage = () => {
                let replaceElement = this.getNoImageElement();

                if (this.propertyImage.url) {
                    replaceElement = this.getImageElement();
                }

                imgLoader.parentNode.replaceChild(replaceElement, imgLoader);
                this.map.infoWindow.setContent(infoWindowContent);
            };
            if (this.propertyImage.loaded) {
                replaceImage();
                return;
            }

            let property = marker.attributes;
            property.getImages(4).then(images => {
                this.propertyImage.loaded = true;

                if (images.length) {
                    this.propertyImage.url = new URL(images[0]);
                    this.propertyImage.url.searchParams.append('width', 252);
                    this.propertyImage.url.searchParams.append('height', 150);
                }

                replaceImage();
            });
        }

        getNoImageElement() {
            let propertyNoImageElement = document.createElement('div');
            propertyNoImageElement.classList.add('property-no-image');

            let imageElement = document.createElement('img');
            imageElement.src = require('./../../../assets/images/property_default.jpg');
            imageElement.classList.add('no-image-placeholder');

            let iconElement = document.createElement('i');
            iconElement.classList.add(...[
                'far',
                'fa-image',
            ]);

            let textElement = document.createElement('span');
            textElement.classList.add('no-photo-text');
            textElement.innerText = 'No Photo';

            propertyNoImageElement.append(imageElement);
            propertyNoImageElement.append(iconElement);
            propertyNoImageElement.append(textElement);

            return propertyNoImageElement;
        }

        getImageElement() {
            let imageElement = document.createElement('img');

            imageElement.src = this.propertyImage.url;
            imageElement.classList.add(...[
                'image-carousel',
                'w-100',
            ]);
            imageElement.setAttribute('alt', 'Property Image');
            imageElement.setAttribute('height', '150');

            return imageElement;
        }

        getInfoWindowOffsetRelativeToMarker(marker) {
            let centerLat = this.map.getCenter().lat();
            let centerLng = this.map.getCenter().lng();

            let markerLat = marker._latLng.lat;
            let markerLng = marker._latLng.lng;


            // dial 1
            if (markerLat >= centerLat && markerLng < centerLng) {
                return new google.maps.Size(170, 350);
            }

            // dial 2
            if (markerLat > centerLat && markerLng >= centerLng) {
                return new google.maps.Size(-170, 350);
            }

            // dial 3
            if (markerLat <= centerLat && markerLng > centerLng) {
                return new google.maps.Size(-170, 50);
            }

            // dial 4
            if (markerLat < centerLat && markerLng <= centerLng) {
                return new google.maps.Size(170, 50);
            }

            return new google.maps.Size(0, 0);
        }

        /**
         * closes active info window set on map object
         */
        closeActiveInfoWindow(activeWindow) {
            let infoWindow = (activeWindow !== undefined) ? activeWindow : (this.map ? this.map.infoWindow : null);
            if (infoWindow) {
                infoWindow.close();
            }
            this.removeActiveMarkerClassList();
        }

        /**
         * adds active classes from active marker
         */
        addActiveMarkerClassList() {
            if (map.activeMarker) {
                map.activeMarker.firstElementChild.classList.add(marker.getActiveIconClass());
                let img = map.activeMarker.querySelector('img');
                if (img) {
                    img.classList.add(marker.getActiveCaretClass());
                }
            }
        }

        /**
         * removes active classes from active marker
         */
        removeActiveMarkerClassList() {
            if (map.activeMarker) {
                map.activeMarker.firstElementChild.classList.remove(marker.getActiveIconClass());
                let img = map.activeMarker.querySelector('img');
                if (img) {

                    img.classList.remove(marker.getActiveCaretClass());
                }
            }
        }

        /**
         * toggle favorite classes to favorite button icon target
         */
        toggleFavoritePropertyClassList(target, isActive) {
            if (isActive) {
                target.classList.add("active");
                target.classList.add("fas");
                target.classList.remove("far");
                return;
            }
            target.classList.remove("active");
            target.classList.remove("fas");
            target.classList.add("far");
        }

        /**
         * Remove the active marker including the balloon from the map
         */
        removeActiveMarkerAndBalloon() {
            if (map.infoWindow) {
                map.infoWindow.close(map, map.activeMarker);
            }
            this.removeActiveMarkerClassList();
        }

        /**
         * Bind the events to the map
         */
        bindEventsToMap() {
            const self = this;
            google.maps.event.addListener(map, 'click', function () {
                self.removeActiveMarkerAndBalloon();
            });
            document.body.addEventListener('click', function (event) {
                let isPropertyCardBalloon = event.target.closest('.property-listing-card-balloon');

                if (isPropertyCardBalloon) {
                    return;
                }
                if (event.target.matches('.property-marker-icon-dot')) {
                    return;
                }

                self.removeActiveMarkerAndBalloon();
            });
        }

        /**
         * method invoked when overlay is drawn on the map
         */
        draw() {
            const point = this.getPointOfMarker();
            const offset = 25;
            this.divWrapper.style.left = `${point.x - offset}px`;
            this.divWrapper.style.top = `${point.y - offset}px`;
        }

        /**
         * @returns {*}
         */
        getPointOfMarker() {
            return this.getProjection().fromLatLngToDivPixel(this.latLng);
        }

        /**
         * @returns {boolean}
         */
        getDraggable() {
            return false;
        }

        /**
         * @returns {google.maps.LatLng}
         */
        getPosition() {
            return this.latLng;
        }
    }

    return new CustomOverlayView();
}
